module.exports = __webpack_public_path__ + "static/2.1_Heart_Hands_icon-01-2115526c3e6eecc29d5c96f402435f40.png";